var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "emd-text",
        {
          class: _vm.classColor,
          attrs: { size: "page", weight: "700", "data-testid": "value" },
        },
        [_vm._v(" " + _vm._s(_vm.sign) + _vm._s(_vm.value) + " ")]
      ),
      _vm.text
        ? _c("div", { staticClass: "eu-mt_2" }, [
            _c(
              "p",
              {
                staticClass: "emd-text",
                class: _vm.classColor,
                attrs: { "data-testid": "text" },
              },
              [_vm._v(" " + _vm._s(_vm.$t(_vm.text)) + " ")]
            ),
          ])
        : _vm._e(),
      _vm._t("tippy"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }